// import firebase from "firebase";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAL2sLSZ3MHfXOv6r94Ph4rpXOb-KlrfWQ",
    authDomain: "slack-flow-messenger.firebaseapp.com",
    projectId: "slack-flow-messenger",
    storageBucket: "slack-flow-messenger.appspot.com",
    messagingSenderId: "498269094058",
    appId: "1:498269094058:web:acd1c6a3125aacdb4750d3",
    measurementId: "G-MNQXYQQKDG"
  };
  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db= firebaseApp.firestore();
  const auth= firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();

  export {auth, provider, db };
